import React from "react";
import { Link } from "react-router-dom";
import { Bell, CircleCheck, Eye, Heart, MessageCircle, Pin } from "lucide-react";
import { TspBadge } from "../../../components/primitives";
import { formatDate } from "../../../utils/tspFormat";

// One topic in the list. The title is a real link to the topic view.
export default function TopicRow({ topic, category }) {
  const solved = topic.solved;

  return (
    <li className={`tsp-topic-row ${topic.pinned ? "tsp-topic-row-pinned" : ""}`}>
      <div className="tsp-topic-main">
        <div className="tsp-topic-badges">
          {topic.pinned && (
            <TspBadge tone="amber">
              <Pin size={11} aria-hidden="true" /> Pinned
            </TspBadge>
          )}
          <TspBadge tone={topic.type === "question" ? "blue" : "neutral"}>{topic.type === "question" ? "Question" : "Discussion"}</TspBadge>
          {solved && (
            <TspBadge tone="green">
              <CircleCheck size={11} aria-hidden="true" /> Solved
            </TspBadge>
          )}
          {category && <TspBadge tone={category.tone}>{category.label}</TspBadge>}
          {topic.subscribed && (
            <span className="tsp-topic-following" title="You are subscribed to this topic">
              <Bell size={12} aria-hidden="true" /> Following
            </span>
          )}
        </div>

        <h3 className="tsp-topic-title">
          <Link to={`/tsp/forum?topic=${encodeURIComponent(topic.id)}`}>{topic.title}</Link>
        </h3>

        <span className="tsp-topic-byline">
          <strong>{topic.author}</strong> · started {formatDate(topic.createdAt)}
          {topic.lastActivityAt !== topic.createdAt && <> · last activity {formatDate(topic.lastActivityAt)}</>}
        </span>
      </div>

      <ul className="tsp-topic-stats" aria-label="Topic activity">
        <li title="Replies" aria-label={`${topic.replies.length} replies`}>
          <MessageCircle size={14} aria-hidden="true" /> {topic.replies.length}
        </li>
        <li title="Likes" aria-label={`${topic.likes} likes`}>
          <Heart size={14} aria-hidden="true" /> {topic.likes}
        </li>
        <li title="Views" aria-label={`${topic.views} views`}>
          <Eye size={14} aria-hidden="true" /> {topic.views}
        </li>
      </ul>
    </li>
  );
}
